import { inject as controller } from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DayDetailControllerBaseController from 'lumen/controllers/day-detail-controller-base';
import { DEFAULT_QP_VALUES } from 'lumen/utils/constants/default-qp-values';
import { RATE_PARAMS } from 'lumen/utils/constants/general-constants';

export default class HotelPricingManagerDetailController extends DayDetailControllerBaseController {
  queryParams = [...this.queryParams, 'edit'];

  @service('hotel-and-market') hotelAndMarketService;
  @service router;
  @service usageAnalytics;

  @controller('hotel.pricing-manager') pricingAssistantController;

  @tracked edit = DEFAULT_QP_VALUES.hotel['pricing-manager'].detail.edit;

  isPricingAssistantProduct = true;

  get isBestFlex() {
    return this.pricingAssistantController?.rateParam === RATE_PARAMS.BEST_FLEX;
  }

  get ratesParams() {
    const { room } = this;

    return {
      los: this.pricingAssistantController?.los,
      mealtype:
        this.pricingAssistantController?.mealPlan === 0
          ? null
          : this.pricingAssistantController?.mealPlan,
      persons: this.pricingAssistantController?.maxPersons,
      membershiptype: this.pricingAssistantController?.membershipType,
      room,
      ota: this.pricingAssistantController?.otaId,
      rateParam: this.pricingAssistantController?.rateParam,
      platform: this.pricingAssistantController?.platform,
      compset:
        this.hotelAndMarketService.availableCompsets?.length > 1
          ? this.pricingAssistantController?.compsetId
          : null,
    };
  }

  @action
  changeDay(next) {
    this.usageAnalytics.track('Date Range Changed', {
      eventTrigger: 'day-detail-modal',
      product: 'pricing-manager',
    });
    this.onToggleEdit(false);
    super.changeDay(next);
  }

  @action
  onToggleEdit(isEditActive) {
    this.router.legacyTransitionTo({
      queryParams: { edit: isEditActive },
    });
  }

  @action
  redirect() {
    this.router.legacyTransitionTo('hotel.pricing-manager');
  }
}
